module.exports = __webpack_public_path__ + "static/media/default-avatar.9c35bbf6.svg";